<label [attr.for]="name" class="block font-medium mb-2" [class]="className">{{ label }}</label>
